import React from "react";
import { useToast } from "@chakra-ui/react";
import { BellScheduleModal } from "../../../../components/BellScheduleModal";

// Thin adapter around the shared, component-based bell schedule modal. The modal
// owns all UI/state (day map, quick-fill, per-row music picker with remote-first
// preview + /public/bells fallback). Here we only bridge its onSave payload to
// the existing bell-upload flow, which maps each row to the save DTO.
function AddBellModal({ isOpen, onClose, handleBellUpload }) {
    const toast = useToast();

    // BellScheduleModal hands back rows shaped as
    //   { name, time, playTime, type, music /* url */, musicId, musicLabel }
    // which is exactly what Bell.js#mapToDTO consumes (music = fileUrl).
    const handleSave = async (bellList) => {
        try {
            await handleBellUpload(bellList);
            toast({
                title: "सफलता!",
                description: "सारा बेलहरू सफलतापूर्वक अपलोड गरियो।",
                status: "success",
                duration: 5000,
                isClosable: true,
            });
            onClose();
        } catch (error) {
            console.error(error);
            toast({
                title: "असफलता!",
                description: "बेल अपलोड गर्न असफल भयो। कृपया पुनः प्रयास गर्नुहोस्।",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    };

    return (
        <BellScheduleModal open={isOpen} onClose={onClose} onSave={handleSave} lang="ne" />
    );
}

export default AddBellModal;
